import { render, staticRenderFns } from "./PetugasBOTidakAktif.vue?vue&type=template&id=ffe75540&"
import script from "./PetugasBOTidakAktif.vue?vue&type=script&lang=js&"
export * from "./PetugasBOTidakAktif.vue?vue&type=script&lang=js&"
import style0 from "./PetugasBOTidakAktif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports